var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Services test")]),_c('div',[_c('StatusTableComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }